import { FC, useEffect, useState } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import SelectComponent from "../../../components/molecule/Select/SelectComponent";
import { Option } from "../../../types/General/Option";
import { SystemStyleObject } from "@chakra-ui/react";
interface FormSelectProps {
  control: Control<any>;
  errors: any;
  watch: UseFormWatch<FieldValues>;
  isDisabled?: boolean;
  fieldName: string;
  fieldLabel: string;
  fetchOptions?: () =>
    | Promise<Option[]>
    | Promise<{ content: Option[]; totalItems: any }>;
  dependencyWatchField?: string;
  dependencyCondition?: (dependencyValue: any) => boolean;
  isRequiredCondition?: (dependencyValue: any) => boolean;
  selectOptions?: Option[];
  additionalStyle?: SystemStyleObject;
  additionalText?: string;
  placeholder?: string;
  defaultValue?: any;
}
const FormSelect: FC<FormSelectProps> = ({
  control,
  errors,
  watch,
  isDisabled = false,
  fieldName,
  fieldLabel,
  fetchOptions,
  dependencyWatchField,
  dependencyCondition,
  isRequiredCondition,
  selectOptions,
  additionalStyle,
  additionalText,
  placeholder,
  defaultValue,
}) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const dependencyValue = dependencyWatchField
    ? watch(dependencyWatchField)
    : null;
  useEffect(() => {
    if (
      fetchOptions &&
      (!dependencyCondition || dependencyCondition(dependencyValue))
    ) {
      setIsLoaded(false);
      fetchOptions()
        .then((result) => {
          if (Array.isArray(result)) {
            setOptions(result);
          } else if (result && result.content) {
            setOptions(result.content);
          } else {
            setOptions([]);
          }
          setTimeout(() => {
            setIsLoaded(true);
          }, 500);
        })
        .catch((error) => {
          console.log("API Error:", error);
          setOptions([]);
          setTimeout(() => {
            setIsLoaded(true);
          }, 500);
        });
    } else if (selectOptions) {
      setOptions(selectOptions);
      setTimeout(() => {
        setIsLoaded(true);
      }, 500);
    } else {
      setOptions([]);
      setTimeout(() => {
        setIsLoaded(true);
      }, 500);
    }
  }, [dependencyValue, fetchOptions, selectOptions, dependencyCondition]);
  return (
    <SelectComponent
      errors={errors}
      fieldNameObject={fieldName}
      options={options}
      fieldName={fieldLabel}
      control={control}
      isDisabled={
        isDisabled ||
        (dependencyCondition && !dependencyCondition(dependencyValue))
      }
      isRequired={
        isRequiredCondition ? isRequiredCondition(dependencyValue) : true
      }
      additionalStyle={additionalStyle}
      additionalText={additionalText}
      placeholder={placeholder}
      defaultValue={defaultValue}
      isLoaded={isLoaded}
    />
  );
};
export default FormSelect;
